import {connect} from 'react-redux'
import PhonereloadView from '../components/PhonereloadView'
import _ from 'lodash'

import {C} from "../../../../helpers";
import {changeStep} from "../../../../layouts/Content/modules/step";
import {submitTransaction} from '../modules/phonereload'
import {appSetVal, appSetServerVal, appSetObj, appCall, checkFields} from '../../../../store/application'


const mapDispatchToProps = {

  appCall: appCall,
  appSetServerVal: appSetServerVal,
  appSetVal: appSetVal,
  appSetObj: appSetObj,
  changeStep: changeStep,
  checkFields: checkFields,

  submitTransaction: submitTransaction
};

const mapStateToProps = (state) => {
  const {ready_to_submit, account, phone_number_validation} = state.app.x_data;

  const {customer_id, phone_number} = state.customer;

  const {icon, title, product_denom_mapping} = state.app.product_data;

  return {
    icon,
    title,
    customer_id,
    denominations: _.map(product_denom_mapping, (v, k) => ({key: k, text: C(v[0], '$'), amount: v[0], value: k})),
    ready_to_submit: !ready_to_submit,
    phone_number,
    account,
    phone_error_type: phone_number_validation && phone_number_validation.type
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(PhonereloadView)


// WEBPACK FOOTER //
// ./src/components/Applications/Phonereload/containers/PhonereloadContainer.js